export default "__VITE_ASSET__DUi7obnW__"